export default function PageHeader({ overline, title, description, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
      <div>
        {overline && (
          <p className="text-xs uppercase tracking-[0.2em] font-semibold text-muted-foreground mb-2">{overline}</p>
        )}
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight leading-none">{title}</h1>
        {description && <p className="text-muted-foreground mt-2 text-sm">{description}</p>}
      </div>
      {children && <div className="flex items-center gap-2 shrink-0">{children}</div>}
    </div>
  );
}
